'use strict';

var React = require('react');
var AllocationAssets = require('./../AllocationAssets.jsx');
var Formatter = require('./../../../utils/Formatter.js');

var InvestmentAllocationItem = React.createClass({
    propTypes: {
        amount: React.PropTypes.number.isRequired,
		assetAllocations: React.PropTypes.array.isRequired,
        name: React.PropTypes.string.isRequired,
        code: React.PropTypes.string.isRequired,
        weight: React.PropTypes.number.isRequired,
        number: React.PropTypes.number.isRequired
    },
    render: function () {
        const amount = this.props.amount ? Formatter.currencyFormat(this.props.amount.toFixed(2), true) : null,
			name = this.props.name ? this.props.name : null,
			code = (this.props.code.trim() === '') ? null : ('# ' + this.props.code),
			weight = this.props.weight ? (this.props.weight.toFixed(2) + '%') : null,
			number = this.props.number ? ((this.props.number + 1) + '. ') : '1. ';

        return (
            <section className="investment-allocation-item">
				<div className="row">
					<div className="col-xs-6 col-md-8">
						<p className="investment-allocation-item__title">{number}{name}</p>
						<p className="investment-allocation-item__code">{code}</p>
					</div>
					<div className="col-xs-3 col-md-2 text-right">
						<p>Amount</p>
                        <p>Allocation</p>
					</div>
					<div className="col-xs-3 col-md-2">
						<p className="investment-allocation-item__amount">{amount}</p>
						<p className="investment-allocation-item__weight">{weight}</p>
					</div>
				</div>
				<div className="row">
					<div className="col-xs-12 col-md-8">
						<AllocationAssets assetAllocations={this.props.assetAllocations}/>
					</div>
				</div>
            </section>
        )
    }
});

module.exports = InvestmentAllocationItem;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ConfirmDetails/InvestmentAllocation/InvestmentAllocationItem.jsx